export const FLOW_NODE_TYPES = {
	DECISION: 'Decision',
	RECORD_CREATE: 'Record Create',
	RECORD_LOOKUP: 'Record Lookup',
	RECORD_UPDATE: 'Record Update'
};
